'use client'

import { UsePromptFormReturn } from "@/lib/types/prompt-area-types"
import { FileDisplay } from "@/components/filesV2/file-display"
import { ContentFile } from "@/lib/types/file-types"

export function PromptAreaFileDisplay({ promptForm }: { promptForm: UsePromptFormReturn }) {
    const handleFileDelete = (file: ContentFile) => {
        // Remove from form files (for completed files)
        const updatedFiles = (promptForm.form.getValues('files') || []).filter((f: ContentFile) => f.id !== file.id)
        promptForm.form.setValue('files', updatedFiles)
        
        // Note: Uploading files are managed by the upload hook automatically
        // Error files can be cleared by the user, but we don't remove them from the hook state here
        // as that's handled by the upload hook's auto-cleanup
    }

    const files = promptForm.form.watch('files') as ContentFile[] | undefined
    
    // Don't render if no files
    if (!files || files.length === 0) {
        return null
    }

    return (
        <FileDisplay
            files={files}
            onFileDelete={handleFileDelete}
            className="overflow-y-hidden"
            cardSize="small"
        />
    )
}